export default "__VITE_PUBLIC_ASSET__6b0b9ef5__"